// Tenant (second-business) build config. Both values are baked in at build time by
// scripts/tenant-build.js; on Hollypaul's own build neither is set, so IS_TENANT is false
// and every page behaves exactly as before.
export const TENANT_MODULES = (process.env.REACT_APP_MODULES || '').split(',').map((s) => s.trim()).filter(Boolean);
export const IS_TENANT = TENANT_MODULES.length > 0;
export const BUSINESS_NAME = process.env.REACT_APP_BUSINESS_NAME || 'Hollypaul';
